import CustomButton from "../../components/custom/button";
import { useAppDispatch } from "../../../app/redux/hooks";
import { showSnackbar } from "../../../app/slices/common/customSnackBar/customSnackbarSlice";
import axios from "../../../axios";
import { useState } from "react";

export const DeleteAccountModal = ({ modalClose }: any) => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    try {
      const resp: any = await axios.post("accounts/delete/");

      // Accept 200 OK as success
      if (resp?.status === 200 || resp?.data?.status === 200) {
        dispatch(
          showSnackbar({
            message: "Your account has been deleted successfully.",
            severity: "success",
            autoHide: 2000,
          })
        );
        // Clear session and redirect to home
        localStorage.clear();
        modalClose();
        window.location.href = "/";
      } else {
        dispatch(
          showSnackbar({
            message: resp?.data?.message || "Please try again later.",
            severity: "error",
            autoHide: 3000,
          })
        );
      }
    } catch (err) {
      dispatch(
        showSnackbar({
          message: "Unable to delete account. Please try again later.",
          severity: "error",
          autoHide: 3000,
        })
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <p>{`Are you sure you want to delete your account? This action cannot be undone.`}</p>
        </div>
      </div>
      <div className="row mt-4 mb-4">
        <div className="col-md-4"></div>{" "}
        <div className="col-md-8">
          <div className="row">
            <div className="col-md-6">
              <CustomButton
                name="Cancel"
                onClick={modalClose}
                color="secondary"
                fullWidth
              />
            </div>
            <div className="col-md-6">
              <CustomButton
                name="OK"
                onClick={handleDelete}
                fullWidth
                loader={loading}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
